import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import type { QueryFilters, ApiError } from '../types';
import { apiGet } from '../../../../api/queries/apiGet';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metrics/authenticationDenyRate';

const fetchAuthenticationDenyRate = async (filters: QueryFilters): Promise<number> => {
    const data = await apiGet<number>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaQueryParams(filters));
    return data;
};

export const useAuthenticationDenyRate = (filters: QueryFilters): UseQueryResult<number, ApiError> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.authenticationDenyRate(filters),
        queryFn: () => fetchAuthenticationDenyRate(filters)
    });
};
